import { render, staticRenderFns } from "./excel-file-svg.vue?vue&type=template&id=4cce31c7&scoped=true&"
var script = {}
import style0 from "./excel-file-svg.vue?vue&type=style&index=0&id=4cce31c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cce31c7",
  null
  
)

export default component.exports